(()=>{
 const boot=()=>{
  const surface=document.getElementById('lumy-buyer-ticker');if(!surface||surface.dataset.ready)return;surface.dataset.ready='true';
  const track=surface.querySelector('.ticker-track'),group=track?.firstElementChild;if(!group)return;
  let copy;try{copy=JSON.parse(surface.querySelector('[data-buyer-ticker-copy]').textContent)}catch{return}
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduced.matches;
  const motion=()=>surface.dataset.paused=String(paused||document.hidden);
  const measure=()=>surface.style.setProperty('--santa-ticker-duration',Math.max(32,group.getBoundingClientRect().width/40)+'s');
  const format=(template,values)=>template.replace(/\{(\w+)\}/g,(_,key)=>String(values[key]??''));
  const update=()=>surface.querySelectorAll('time[datetime]').forEach(time=>{
   const stamp=Date.parse(time.dateTime);if(!Number.isFinite(stamp))return;
   const minutes=Math.max(0,Math.floor((Date.now()-stamp)/60000));
   time.textContent=minutes<1?copy.justNow:minutes<60?format(copy.minutes,{minutes}):minutes<1440?format(copy.hours,{hours:Math.floor(minutes/60),minutes:minutes%60}):format(copy.days,{days:Math.floor(minutes/1440),hours:Math.floor(minutes%1440/60)});
  });
  surface.addEventListener('keydown',event=>{if(event.target===surface&&(event.code==='Space'||event.key==='Escape')){event.preventDefault();paused=event.key==='Escape'||!paused;motion()}});
  reduced.addEventListener('change',()=>{paused=reduced.matches;motion()});
  document.addEventListener('visibilitychange',()=>{motion();if(!document.hidden)update()});
  if('ResizeObserver' in window)new ResizeObserver(measure).observe(group);else window.addEventListener('resize',measure,{passive:true});
  measure();motion();update();setInterval(update,60000);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

